import { EventEmitter } from 'events';

import { useLayoutEffect } from 'react';

import { IntelligenceGlobalEventEmitters } from './useIntelligenceEvents.types';
import { useIntelligenceAnalyticsEvents } from './utils/useIntelligenceAnalyticsEvents';
import { useIntelligenceConversationEvents } from './utils/useIntelligenceConversationEvents';
import { useIntelligenceTrackingEvents } from './utils/useIntelligenceTrackingEvents';

const createEmitters = (): IntelligenceGlobalEventEmitters => ({
  appEvents: new EventEmitter() as IntelligenceGlobalEventEmitters['appEvents'],
  ampliEvents:
    new EventEmitter() as IntelligenceGlobalEventEmitters['ampliEvents'],
});

export const useIntelligenceEvents = (): void => {
  useLayoutEffect(() => {
    if (typeof window === 'undefined') return;

    if (!window._intelligence) {
      window._intelligence = createEmitters();
    }

    return () => {
      if (typeof window === 'undefined') return;

      const { appEvents, ampliEvents } = window._intelligence;
      appEvents.removeAllListeners();
      ampliEvents.removeAllListeners();
    };
  }, []);

  useIntelligenceAnalyticsEvents();
  useIntelligenceConversationEvents();
  useIntelligenceTrackingEvents();
};
